import { Part } from "./part"

export class Cart {
  id: number
  city: string
  state: string
  zip: string
  country: string
  parts: Part[]
  subtotal: number
  tax: number
  total: number
  user_id: number
  shipping: number
  customer_profile_id: string
  payment_profile_id: string
  shipping_profile_id: string
  constructor({
    id = 0,
    city = '',
    state  = '',
    zip = '',
    country = '',
    subtotal = 0,
    tax = 0,
    total = 0,
    user_id = 0,
    shipping = 0,
    customer_profile_id = '',
    payment_profile_id = '',
    shipping_profile_id = '',
    ...rest
  }) {
    this.id = id
    this.city = city
    this.state = state
    this.zip = zip
    this.country = country
    this.parts = rest.parts && rest.parts.length ? rest.parts.map(x => new Part(x)) : []
    this.subtotal = subtotal
    this.tax = tax
    this.total = total
    this.user_id = user_id
    this.shipping = shipping
    this.customer_profile_id = customer_profile_id
    this.payment_profile_id = payment_profile_id
    this.shipping_profile_id = shipping_profile_id
  }
}
